import { AddToCart } from "../components";
import { useNavigate } from "react-router-dom";

const ProductCart = (props) => {
  const { product } = props;
  const navigate = useNavigate();

  function truncateString(str, maxLength) {
    if (str.length > maxLength) {
      return str.slice(0, maxLength) + "...";
    }
    return str;
  }

  const basePrice = Number(product.salePrice) || 0;
  const applyDiscount = basePrice / 1.15;
  const salePrice = applyDiscount.toFixed(2);

  return (
    <div
      className="main__card"
      onClick={() => {
        props.handleProductClick(product);
        navigate(`/product/${product.id}`);
      }}
    >
      <img src={product.media[0]} alt="product" className="main__img" />
      <h3 className="main__name">{truncateString(product.name, 35)}</h3>
      <div className="main__prices">
        <p className="main__regprice">
          <span>&#163;</span>
          {product.salePrice}
        </p>
        <p className="main__saleprice">
          <span>&#163;</span>
          {salePrice}
        </p>
      </div>
      <AddToCart
        addToCart={props.addToCart}
        product={product}
        salePrice={salePrice}
      />
    </div>
  );
};

export default ProductCart;
